import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UiClasses } from '@sb-shared/types/ui-classes';

@Component({
  selector: 'sb-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  standalone: false
})
export class AlertDialogComponent {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() messageArray: string[] = [];
  @Input() translateMessage: boolean = true;
  @Input() messageTranslationParameters: any = null;
  @Input() headerClass: UiClasses = '';
  @Input() iconClass: string = '';
  @Input() okButtonText: string = 'SB_OK';
  @Input() okButtonClass: UiClasses = 'success';
  @Input() cancelButtonText: string = '';

  constructor(public activeModal: NgbActiveModal) {}

  ok(): void {
    this.activeModal.close(true);
  }

  cancel(): void {
    this.activeModal.dismiss('cancel');
  }
}
